// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__2CF5o","modalFooterButton":"ModalNotes_modalFooterButton__2aEWH"};